import Box from "@/ui/atoms/Box";
import Typography from "@/ui/atoms/Typography";
import { Modal } from "@proda-ai/ui-kit";

export const testIds = {
    main: "ExtractionConversionModal-modal",
};
export type ExtractionConversionModalProps = {
    showModal: boolean;
    conflictingExtractions: number[] | null;
    extractionsInfo:
        | {
              fileName: string;
              extractionId: number;
              sheetName: string;
          }[]
        | null;
    onConfirm: () => void;
    onCancel: () => void;
};

export const ExtractionConversionModal = ({
    showModal,
    conflictingExtractions,
    extractionsInfo,
    onConfirm,
    onCancel,
}: ExtractionConversionModalProps) => {
    const modalTitle =
        "Are you sure you want to convert this extraction to a draft?";

    return (
        <Modal
            data-testid={testIds.main}
            open={showModal}
            headerTitle={modalTitle}
            onCancel={onCancel}
            onClose={onCancel}
            onConfirm={onConfirm}
            textCancel="Cancel"
            textConfirm="Confirm"
        >
            <Typography variant="body3">
                <Box sx={{ marginBottom: "1rem" }}>
                    By converting this extraction to a draft, it will no longer
                    be included in the <strong>Operating Statement</strong>{" "}
                    table.
                </Box>
                {conflictingExtractions &&
                    conflictingExtractions.length > 0 && (
                        <>
                            <p>
                                <strong>Warning: </strong>This extraction has
                                conflicts with the following extractions so they
                                will also be converted to drafts.
                            </p>
                            <Box
                                component="ul"
                                sx={{
                                    listStyleType: "disc",
                                    paddingLeft: "30px",
                                }}
                            >
                                {conflictingExtractions.map(extractionId => {
                                    const extraction = extractionsInfo?.find(
                                        extraction =>
                                            extraction.extractionId ===
                                            extractionId,
                                    );
                                    return (
                                        <Box
                                            component="li"
                                            key={extractionId}
                                            data-testid={`ExtractionConversionModal-conflictingExtraction-${extractionId}`}
                                        >
                                            {`Extraction 
                                            ${extraction?.extractionId} -
                                            ${extraction?.fileName}`}
                                        </Box>
                                    );
                                })}
                            </Box>
                        </>
                    )}
            </Typography>
        </Modal>
    );
};
